import { init, getLocaleFromNavigator, addMessages } from 'svelte-i18n';
import en from '../lang/en.json';
import it from '../lang/it.json';

// Register languages file
function setLocale() {
    addMessages('en', en);
    addMessages('it', it);

    if (localStorage.getItem('locale')) {
        init({
            fallbackLocale: 'en',
            initialLocale: localStorage.getItem('locale'),
        });
    }else{
        init({
            fallbackLocale: 'en',
            initialLocale: getLocaleFromNavigator(),
        });
        localStorage.setItem('locale', getLocaleFromNavigator());
    }
}

function changeLocale(lang) {
    init({
        fallbackLocale: 'en',
        initialLocale: lang,
    });

    localStorage.setItem('locale', lang);
    location.reload();
}

export { setLocale, changeLocale };